export const PAYMENT_METHODS = {
  card: "card",
  ach: "ach",
};

export const PAYMENT_STATUS = {
  success: "success",
  error: "error",
};

export const PAYMENT_PLAN_TYPES = {
  payInFull: "payInFull",
  paymentPartial: "paymentPartial",
  paymentPlan: "paymentPlan",
  settleInFull: "settleInFull",
  settlementPlan: "settlementPlan",
};

export const PAYMENT_PLAN_MIXPANEL_TYPES = {
  specialPaymentPlan: "specialPaymentPlan",
  specialPayInFull: "specialPayInFull",
};

export const PAYMENT_FREQUENCIES = {
  weekly: "weekly",
  everyTwoWeeks: "everyTwoWeeks",
  biweekly: "biweekly",
  monthly: "monthly",
};

export const PAYMENT_BIWEEKLY_CADENCES = {
  firstAndFifteenth: "firstAndFifteenth",
  fifteenthAndLastDay: "fifteenthAndLastDay",
};

export const PAYMENT_FREQUENCY_MAPPINGS = {
  1: PAYMENT_FREQUENCIES.monthly,
  2: PAYMENT_FREQUENCIES.biweekly,
  4: PAYMENT_FREQUENCIES.weekly,
};

// matches NegotiablePlanType enum in API
export const NEGOTIABLE_PLAN_TYPES = {
  specialPaymentPlan: "specialpaymentplan",
  paymentPlan: "paymentplan",
  settlementPlan: "settlementplan",
};

export const DISCOUNT_TYPES = {
  SETTLEMENT: "SETTLEMENT",
  PROMO_CODE: "PROMO_CODE",
};
